<template>
  <div class="portada-arley" ref="rootRef" aria-label="Portada de XV Años">
    <div class="fondo-gradiente">
      <div class="fondo-arco"></div>
    </div>

    <img src="@/assets/vela.avif" class="adorno velas-superior" alt="" />
    <img src="@/assets/Elements (63).avif" class="flor flor-superior-derecha" alt="" />

    <img src="@/assets/brillo.avif" class="brillo brillo-izq-1" alt="" />
    <img src="@/assets/brillo.avif" class="brillo brillo-izq-2" alt="" />
    <img src="@/assets/brillo.avif" class="brillo brillo-der-1" alt="" />
    <img src="@/assets/brillo.avif" class="brillo brillo-der-2" alt="" />

    <img src="@/assets/Elements (63).avif" class="flor-grande flor-izq-1" alt="" />
    <img src="@/assets/Elements (63).avif" class="flor-grande flor-izq-2" alt="" />
    <img src="@/assets/flor-izq.avif" class="flor-grande flor-izq-3" alt="" />

    <img src="@/assets/flor-izq.avif" class="flor-grande flor-der-1" alt="" />
    <img src="@/assets/Elements (63).avif" class="flor-grande flor-der-2" alt="" />
    <img src="@/assets/flor-izq.avif" class="flor-grande flor-der-3" alt="" />

    <div class="imagen-xv-wrapper shadow-custom">
      <img src="@/assets/M5.webp" class="imagen-xv" alt="Foto protagonista" />
    </div>

    <header class="texto-cabecera">
      <p class="prefijo-xv text-uppercase">MIS XV</p>
      <h1 class="nombre-mariel">
        <span class="nombre-principal">Luisa</span>
        <span class="apellido-principal">Fernanda </span>
      </h1>
    </header>
        <div class="rasgado rasgado-inferior"></div>

   
  </div>
</template>

<script>
import { onMounted, ref, nextTick } from 'vue'
import gsap from 'gsap'

export default {
  name: 'PortadaArley',
  setup() {
    const rootRef = ref(null)

    onMounted(async () => {
      await nextTick()

      const $ = (sel) => Array.from(gsap.utils.toArray(sel)).filter(Boolean)

      // Elementos a animar
      const fondo = $('.fondo-gradiente')
      const arco = $('.fondo-arco')
      const foto = $('.imagen-xv-wrapper')
      const textos = $('.texto-cabecera, .controles-inferiores, .parrafo-presentacion-wrapper')
      const floresNormales = $('.velas-superior, .flor-superior-derecha')
      const floresGrandes = $('.flor-grande')
      const brillos = $('.brillo')
      const controles = $('.controles-inferiores')
      const playIcon = $('.play-icon')
      const seekBar = $('.seek-bar')

      // Configuración inicial sin spread operators
      const totalElementos = [].concat(fondo, arco, foto, textos, floresNormales, floresGrandes, brillos, controles, playIcon, seekBar)
      gsap.set(totalElementos, { autoAlpha: 0, y: 30 })
      gsap.set(brillos, { scale: 0 })

      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (!e.isIntersecting) return

          const tl = gsap.timeline({ defaults: { ease: 'power2.out' } })

          // 1. Animación del fondo y el arco
          tl.to(fondo, { autoAlpha: 1, y: 0, duration: 1 })
            .to(arco, { autoAlpha: 1, y: 0, duration: 0.8 }, '-=0.6')

          // 2. Animación de la foto protagonista
          tl.fromTo(
            foto,
            { scale: 0.9, y: 50, filter: 'blur(8px)' },
            { autoAlpha: 1, scale: 1, y: 0, filter: 'blur(0px)', duration: 1.3 },
            '-=0.4'
          )

          // 3. Animación de textos y flores superiores
          const textosYFlores = [].concat(textos, floresNormales)
          tl.to(
            textosYFlores,
            {
              autoAlpha: 1,
              y: 0,
              duration: 1,
              stagger: 0.15
            },
            '-=0.8'
          )

          // 4. Animación de las 6 flores laterales
          tl.to(
            floresGrandes,
            {
              autoAlpha: 1,
              y: 0,
              rotate: () => gsap.utils.random(-6, 6),
              duration: 1,
              stagger: 0.12
            },
            '-=0.5'
          )

          // 5. Animación de los brillos combinados
          tl.to(
            brillos,
            {
              autoAlpha: 1,
              scale: 1,
              duration: 1,
              stagger: 0.2,
              onComplete: () => {
                gsap.to(brillos, {
                  opacity: 0.6,
                  scale: 1.1,
                  duration: 0.8,
                  repeat: -1,
                  yoyo: true,
                  ease: 'sine.inOut'
                })
              }
            },
            '-=0.3'
          )

          // 6. Animación de los controles de play
          tl.to(controles, { autoAlpha: 1, y: 0, duration: 0.8 }, '-=0.2')
            .to([playIcon, seekBar], { autoAlpha: 1, scale: 1, duration: 0.6, stagger: 0.2 }, '-=0.4')
            .to('.triangle-play', { scale: 1.1, duration: 0.4, repeat: -1, yoyo: true, ease: 'back.out(2)' }, '-=0.2')

          // Movimiento continuo orgánico en todas las flores
          const todasLasFlores = [].concat(floresNormales, floresGrandes)
          todasLasFlores.forEach((flor, i) => {
            gsap.to(flor, {
              y: `+=${gsap.utils.random(5, 12)}`,
              x: `+=${gsap.utils.random(-5, 5)}`,
              rotation: `+=${gsap.utils.random(-1, 1)}`,
              duration: gsap.utils.random(3, 4.5),
              repeat: -1,
              yoyo: true,
              ease: 'sine.inOut',
              delay: i * 0.15
            })
          })

          // Sutil respiración de la foto
          gsap.to(foto, {
            scale: 1.012,
            duration: 4,
            yoyo: true,
            repeat: -1,
            ease: 'sine.inOut'
          })
          
          // Movimiento de seek handle
          gsap.to('.seek-handle', {
            x: '90%',
            duration: 20,
            repeat: -1,
            yoyo: true,
            ease: 'none'
          })

          io.disconnect()
        })
      }, { threshold: 0.45 })

      if (rootRef.value) io.observe(rootRef.value)
    })

    return { rootRef }
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;700&family=Montserrat:wght@400;700&family=Great+Vibes&display=swap');

.portada-arley {
  position: relative;
  width: 100%;
  min-height: 100vh;
  background:
    linear-gradient(
      rgba(229, 165, 168, 0.813),
      rgba(208, 152, 180, 0.349)
    ),
    url('@/assets/bn.avif') center center / cover no-repeat;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;  overflow: visible;

  padding: 48px 16px 56px;
  box-sizing: border-box;
}

/* FONDO (GRADIENTE Y ARCO) */
.fondo-gradiente {
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  background: linear-gradient(180deg, #d2b4a3 0%, #c4a18d 60%, #fff 100%);
  z-index: -2;
}

.fondo-arco {
  position: absolute;
  top: 15vh;
  left: 50%;
  transform: translateX(-50%);
  width: min(92vw, 360px);
  height: 80vh;
  border-radius: 180px 180px 0 0;
  background: #fdf2f3;
  z-index: -1;
}

/* IMAGEN CENTRAL */
.imagen-xv-wrapper {
  width: min(92vw, 360px);
  height: calc(min(92vw, 360px) * 1.5);
  margin-top: 29vh;
  margin-bottom: auto;
  border-radius: 180px 180px 0 0;
  overflow: hidden;
  z-index: 2;
  background: #fff;
  will-change: transform, filter, opacity;
}

.imagen-xv {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.shadow-custom {
  box-shadow: 
    0 12px 40px rgba(0,0,0,.18),
    0 2px 8px rgba(0,0,0,.06);
}

/* TEXTOS */
.texto-cabecera {
  max-width: 620px;
  text-align: center;
  position: absolute;
  top: 6vh;
  left: 50%;
  transform: translateX(-50%);
  z-index: 3;
}

.prefijo-xv {
  font-family: 'bethany', sans-serif;
  font-weight: 700;
  font-size: clamp(16px, 2vw, 18px);
  color: #fff;
  margin: 0;  letter-spacing: 4px;

  margin-top: 70px;
  padding-bottom: 19px;
  letter-spacing: 0.15em;
}

.nombre-mariel {
  margin: 0;
  line-height: 1.1;
}

.nombre-principal {
  font-family: 'Great Vibes', cursive;
  font-weight: 400;
  font-size: clamp(48px, 19vw, 60px);
  color: #fff;
  display: block;

  letter-spacing: 4px;
}

.apellido-principal {
  font-family: 'Great Vibes', cursive;
  font-weight: 400;
  font-size: clamp(48px, 19vw, 60px);
  color: #fff;
  display: block;

  letter-spacing: 4px;
}

.parrafo-presentacion-wrapper {
  margin-top: 22px;
  width: 100%;
  max-width: 620px;
  text-align: center;
}

.parrafo-presentacion {
  font-family: 'Playfair Display', serif;
  font-size: clamp(14px, 2.6vw, 16px);
  color: #3d3c3c;
  line-height: 1.7;
  margin-top: 6px;
}

.salmo-ref {
  display: block;
  text-align: right;
  margin-top: 6px;
  font-size: 13px;
  color: #888;
  font-family: 'Montserrat', sans-serif;
  opacity: 0.8;
}

/* ELEMENTOS GRÁFICOS */
.flor, .flor-grande, .adorno, .brillo {
  position: absolute;
  transform-origin: center;
  will-change: transform, opacity;
  object-fit: contain;
}

.adorno.velas-superior {
  top: -210px; right:-220px; z-index: 1;
  width: min(550vw, 550px);
    transform: rotate(8deg);



}

.flor-superior-derecha {
  top: 10px; right: -20px; z-index: 1;
  width: min(25vw, 100px);
}

/* 3 FLORES IZQUIERDAS (DISTRIBUIDAS) */
.flor-izq-1 {
  top: 28vh; left: -19vw; z-index: 3;
  width: min(44vw, 140px);
      

}
.flor-izq-2 {
  top: 2vh; left: -65vw !important; z-index: 3;
  width: min(38vw, 80px) !important;
}
.flor-izq-3 {
  bottom: 38vh; left: -22vw !important; z-index: 3;
  width: min(39vw, 140px) !important;
    transform: rotate(62deg) !important;

}

/* 3 FLORES DERECHAS (DISTRIBUIDAS) */
.flor-der-1 {
  top: 32vh; right: -39vw; z-index: 1;
  width: min(70vw, 310px);
  transform: rotate(-12deg) !important;
}
.flor-der-2 {
  bottom: 10vh; right: -12vw; z-index: 3;
  width: min(46vw, 110px);
}
.flor-der-3 {
  bottom: 8vh; right: -10vw; z-index: -10;
  width: min(44vw, 240px);
}

/* BRILLOS IZQUIERDA */
.brillo-izq-1 {
  top: -5px; left: -18vw; z-index: 0;
  width: 320px; opacity: 0.6;
}
.brillo-izq-2 {
  bottom: 28vh; left: 5vw; z-index: 4;
  width: 100px; opacity: 0.5;
}

/* BRILLOS DERECHA */
.brillo-der-1 {
  top: 22vh; right: 6vw; z-index: 0;
  width: 110px; opacity: 0.6;
}
.brillo-der-2 {
  bottom: 7vh; right: -3vh; z-index: 4;
  width: 140px; opacity: 0.7;
}

/* CONTROLES INFERIORES */
.controles-inferiores {
  width: min(92vw, 360px);
  position: relative;
  z-index: 5;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.play-button-bar {
  display: flex;
  align-items: center;
  background: rgba(255, 255, 255, 0.4);
  backdrop-filter: blur(4px);
  border-radius: 50px;
  padding: 8px;
  width: 100%;
  border: 1px solid rgba(255, 255, 255, 0.3);
  box-sizing: border-box;
}

.play-icon {
  background: #fff;
  border-radius: 50%;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  box-shadow: 0 4px 10px rgba(0,0,0,0.1);
}

.triangle-play {
  width: 0;
  height: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-left: 16px solid #e1b4b9;
  margin-left: 4px;
  transform-origin: center;
}

.seek-bar {
  flex: 1;
  height: 10px;
  background: #d4cfcc;
  border-radius: 5px;
  position: relative;
  overflow: hidden;
}

.seek-handle {
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, #fff, transparent);
  position: absolute;
  top: 0; left: 0;
  border-radius: 5px;
}

.press-play {
  font-family: 'Montserrat', sans-serif;
  font-weight: 700;
  font-size: clamp(14px, 1.8vw, 16px);
  color: #fff;
  margin: 12px 0 0;
  letter-spacing: 0.15em;
  opacity: 0.9;
}

/* Responsive */
@media (min-width: 992px){
  .portada-arley { padding-top: 64px; }
  .texto-cabecera { top: 8vh; }
}

@media (max-width: 500px) {
  .flor-izq-1, .flor-izq-2, .flor-izq-3 { left: -14vw; }
  .flor-der-1, .flor-der-2, .flor-der-3 { right: -14vw; }
}

/* =========================
   RASGADOS
========================= */
.rasgado{
  position:absolute;
  left:0;
  width:100%;
  height:50px;
  background:#ffffff;
  z-index:3;
  margin-top:-40px;
  pointer-events:none;
}


.rasgado-inferior{
  bottom:0;  overflow: visible;
  background:

    linear-gradient(
      rgba(232, 215, 215, 0.758),
      rgba(237, 217, 227, 0.897)
    ),
    url('@/assets/fn.avif') center center / cover no-repeat;
  clip-path: polygon(
    0% 20%, 25% 40%, 50% 15%, 75% 45%, 100% 25%,
    100% 100%, 0% 100%
  );
}

</style>